   @import '../../global/style/all-tenants/custom-properties/components-properties/splide-sliders';

   .container-observed {
     height: px-to-rem(1);
     width: var(--cms-container-width);
   }

   .container {
     position: relative;
     @include cms-default-grid-container;
     margin-bottom: var(--cms-components-mb);
     top: 0;
     z-index: 15;
     overflow-y: hidden;

     &.hidden {
       height: 0;
     }
   }

   .splide {
     --cms-container-width: calc(100% - var(--cms-spacing-400));
     @include splide-root;
     position: unset;
     height: 3.625rem;
     padding: 0 var(--cms-spacing-100);
   }

   .splide__sr {
     @include splide-sr;
   }

   .splide__track {
     @include splide-track;
     height: 3.625rem;
   }

   .splide__list {
     --cms-grid-gap: var(--cms-spacing-075);
     @include splide-list;
     grid-auto-columns: max-content;

   }

   .splide.is-initialized:not(.is-active) .splide__list {
     @include splide-initialized-not-active;
   }

   .splide.is-initialized,
   .splide.is-rendered {
     @include splide-initialized-rendered;
   }

   .splide__slide {
     @include splide-slide;
     min-width: max-content;
   }



   .splide__arrow {
     --cms-arrow-top: 50%;
     --cms-arrow-transform: translateY(-50%);
     @include splide-arrow;
     display: flex;
     margin-top: 0;
   }

   .splide__arrow--prev {
     --cms-arrow-prev-left: var(--cms-spacing-100);
     @include splide-arrow-prev;
   }

   .splide__arrow--next {
     --cms-arrow-next-right: var(--cms-spacing-100);
     @include splide-arrow-next;
   }

   .container-sticky {
     position: sticky;
   }

   .wrapper-inner {
     margin: auto;
   }

   .visible {
     visibility: visible;
   }

   .link {
     align-items: center;
     display: flex;
     --cms-text-color: var(--cms-theme-text-color);
     --cms-link-decoration: none;
     --cms-link-decoration-hover: none;
     text-decoration: none;
     padding: 0 var(--cms-spacing-075);
     height: 100%;
     @include label-font-100;

     &.active {
       text-decoration: underline;
     }

     &:focus-visible {
       border: none;
       outline: none;
     }
   }



   .splide-keyvisual-navi-slide:focus,
   .link {
     outline: none;
   }

   .nav-container-sticky {
     background-color: var(--cms-semanticColors-base-inverted-medium-background);
     z-index: 1000;

     .link {
       --cms-text-color: var(--cms-semanticColors-base-inverted-strong-text);

       &:hover {
         background: var(--cms-semanticColors-base-strong-hover-background);
       }
     }

     .splide__arrow {
       --cms-button-border-color: var(--cms-semanticColors-base-inverted-strong-border);
       --cms-button-hover-color: var(--cms-semanticColors-transparency-inverted-strong-hover-background);
       --cms-button-active-color: var(--cms-semanticColors-transparency-inverted-strong-active-background);
       --cms-button-focus-color: var(--cms-semanticColors-base-inverted-focus-outline);
       --cms-theme-svg-color: var(--cms-semanticColors-transparency-inverted-strong-iconOnBackground);
     }
   }